module.exports = __webpack_public_path__ + "static/media/github.4097a5be.svg";